import Component from '@glimmer/component'
import type { UIScopeName } from 'teacher-ui-client/reporting/ui-scope/route'
import type { ReportData } from 'teacher-ui-client/components/reporting/writing-legends/quizzes-completed/history/report-loader'
import { HistoryTable } from 'teacher-ui-client/components/reporting/writing-legends/quizzes-completed/history/table'
import { HistoryChart } from 'teacher-ui-client/components/reporting/writing-legends/quizzes-completed/history/chart'
import { BasePageSelector as PageSelector } from 'teacher-ui-client/components/base/page-selector'
import { SubscriptionType } from 'teacher-ui-client/subscription-type/subscription-types'
import type SessionService from 'teacher-ui-client/services/session'
import { service } from '@ember/service'

interface ReportSignature {
  Args: {
    isReloading?: boolean
    scopeName: UIScopeName
    reportData: ReportData
  }
}

export class HistoryReport extends Component<ReportSignature> {
  @service session!: SessionService

  get isSubco() {
    return this.session.currentTeacher.subcoFor(SubscriptionType.Writing)
  }

  get showChart() {
    return this.args.scopeName !== 'school'
  }

  get historyTableWidth() {
    if (!this.showChart) {
      return 'w-full'
    }
    return this.isSubco ? 'w-2/3' : 'w-1/2'
  }

  get historyChartWidth() {
    return this.isSubco ? 'w-1/3' : 'w-1/2'
  }

  <template>
    <div class="flex overflow-x-auto print:block print:max-h-[unset] print:overflow-visible">
      <HistoryTable
        data-test-history-table
        class="{{this.historyTableWidth}} border-dusty-black-200 border-b print:w-full"
        @isReloading={{@isReloading}}
        @isSubco={{this.isSubco}}
        @studentsReportData={{@reportData.students}}
      />
      {{#if this.showChart}}
        <HistoryChart
          data-test-history-chart
          class="{{if @isReloading 'opacity-50'}} {{this.historyChartWidth}} print:hidden"
          @studentsReportData={{@reportData.students}}
        />
      {{/if}}
    </div>
    <PageSelector
      class="mx-2 py-3"
      @pageCount={{@reportData.meta.total_pages}}
      @itemCount={{@reportData.meta.total_entries}}
    />
  </template>
}
